module.exports = __webpack_public_path__ + "img/card-bg5.9717351f.jpg";